<div class="countries">
  @for (item of countries; track $index) {
    <div class="item" (click)="onCountrySelected(item)">
      <p class="emoji">{{ item.flag }}</p>
      <p>+{{ item.ddi }}</p>
      <p>{{ item.name }}</p>
    </div>
  }
</div>
